export const IPortalUser = {
  id: 1,
  uid: '4abb487c-ee5b-4fce-8590-e995464a5330',
  email: 'a@a.com',
  business_id: 1,
  store_ids: [0],
  role_id: 1,
  first_name: 'Kasra',
  surname: 'Karami',
  last_login: 'Tue Aug 22 2023 13:33:55 GMT+0000 (Coordinated Universal Time)',
  is_archive: false,
  created_at: 'Tue Aug 22 2023 13:33:55 GMT+0000 (Coordinated Universal Time)',
  updated_at: 'Tue Aug 22 2023 13:33:55 GMT+0000 (Coordinated Universal Time)',
  archived_at: '',
}

export const ILoginData = {
  business_url: 'https://api-stage.techsuite.ai',
  assets_url: 'https://assets-dev.techsuite.ai',
  socket_url: 'https://api-sct0.techsuite.ai',
  partner_name: 'Tech Suite',
  partner_logo_url: 'https://assets-dev.techsuite.ai/base/ts.svg',
  currency_code: 'gbp',
  business_name: 'C1 Business',
  business_logo: '',
}
